import IPartnerWalletSettingsBase from "@/module/main/dto/financing-v3/IPartnerWalletSettingsBase";
import IPartnerWalletOrderBase from "@/module/main/dto/financing-v3/IPartnerWalletOrderBase";

export default class PartnerWalletSettingsBase implements IPartnerWalletSettingsBase
{
    public readonly order?: IPartnerWalletOrderBase;
    public readonly walletUuid?: string;

    constructor(props: IPartnerWalletSettingsBase)
    {
        this.order = props.order;
        this.walletUuid = props.walletUuid;
    }
}
